import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import * as imagesLoaded from 'imagesloaded';
import { TweenMax, Power2 } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {pJS} from 'particles.js';
gsap.registerPlugin(ScrollTrigger);


export function index(){
  const appContainer = document.getElementById('app-container')
  const firstview = document.getElementById('firstview');

  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh',`${vh}px`)

	const particles = document.getElementById('particles');
	const particlePath = './dist/json/particlesjs-config.json'
	if(particles){
		particlesJS.load('particles', particlePath);
	}

  if(firstview){
    const firstviewData = document.getElementById('firstviewData')
    if(firstviewData){
      gsap.fromTo(
        firstviewData,
        {
          opacity: 1,
          scale: 1,
          filter: 'blur(0px)',
          //blur: 0,
        },
        {
          opacity: 0,
          scale: 1.1,
          filter: 'blur(40px)',
          //blur: '50px',
          duration: 1,
          scrollTrigger: {
            ease: Power2.easeIn,
            trigger: firstview,
            start: "top top",
            end: "+=200%",
            scrub: true,
            //markers: true
          },
        }
      )
    }
  }

  const header = document.getElementById('site-header')
  const headerBg = document.getElementById('headerBg')
  if(header){
    gsap.fromTo(
      header,
      {
        borderBottomColor: 'rgba(255,255,255,.12)',
      },
      {
        borderBottomColor: 'rgba(255,255,255,.24)',
        duration: 1,
        scrollTrigger: {
          ease: Power2.easeIn,
          trigger: firstview,
          start: "top top",
          end: "+=100%",
          scrub: true,
          //markers: true
        },
      }
    )
    gsap.fromTo(
      headerBg,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          ease: Power2.easeIn,
          trigger: firstview,
          start: "top top",
          end: "+=100%",
          scrub: true,
          //markers: true
        },
      }
    )
    ScrollTrigger.create({
      trigger: '#site-content',
      //markers: true,
      start: "top 25%",
      once: false,
      toggleClass: {targets: '#site-header, #site-header h1, #bottomfix', className: "active"},
    });
  }

  const scrolEvents = document.querySelectorAll(".scroll-event")
  scrolEvents.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })


  /*
  const siteHeader = document.getElementById('site-header');
  if(siteHeader){
    ScrollTrigger.create({
      trigger: firstview,
      pin: siteHeader,
      //markers: true,
      start: "top top",
      end: "bottom -200%",
    });
  }

  if(firstview){
    ScrollTrigger.create({
      trigger: firstview,
      pin: firstview,
      //markers: true,
      start: "top top",
      end: "bottom -100%",
      onEnter: () => {
        const imgLoading = document.getElementById('img-loading')
        imagesLoaded(imgLoading, function(){
          firstview.classList.add('active')
          imgLoading.classList.add('active')
        });
      },
    });

    const firstviewCatch = document.getElementById('firstviewCatch');
    gsap.fromTo(
      firstviewCatch,
      {
        opacity: 1,
      },
      {
        width: '100vw',
        height: '100vh',
        borderRadius: 0,
        opacity: 1,
        duration: 1,
        scrollTrigger: {
          ease: Power2.easeIn,
          trigger: document.body,
          start: "top top",
          end: "top -100%",
          scrub: true,
          //markers: true
        },
      }
    )

    const firstviewBg = document.getElementById('firstviewBg');
    gsap.fromTo(
      firstviewBg,
      {
        opacity: 0,
      },
      {
        opacity: .88,
        duration: 1,
        scrollTrigger: {
          ease: Power2.easeIn,
          trigger: document.body,
          start: "top top",
          end: "top -100%",
          scrub: true,
          //markers: true
        },
      }
    )

    const firstviewNext = document.querySelectorAll('.firstview__next')
    firstviewNext.forEach((el) => {
      gsap.fromTo(
        el,
        {
          opacity: 0,
          y: 80,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            ease: Power2.easeIn,
            trigger: document.body,
            start: "top -50%",
            end: "top -150%",
            scrub: true,
            //markers: true
          },
        }
      )
    })
    
    const firstviewFadeOut = document.querySelectorAll('.firstviewFadeOut')
    firstviewFadeOut.forEach((el) => {
      let rY = 90;
      if(el.classList.contains('firstview__box__txt')){
        rY = -90
      }
      gsap.fromTo(
        el,
        {
          opacity: 1,
        },
        {
          opacity: 0,
          scale: .88,
          rotateX: rY,
          duration: 1,
          scrollTrigger: {
            ease: Power2.easeIn,
            trigger: document.body,
            start: 'top top',
            end: 'top -50%',
            scrub: true,
            //markers: true
          },
        }
      )
    })
  }

  const scrolEvents = document.querySelectorAll(".scroll-event")
  scrolEvents.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })

  const scrollToggle = document.querySelectorAll(".scroll-toggle")
  scrollToggle.forEach((el) => {
    ScrollTrigger.create({
      trigger: el,
      //markers: true,
      start: "top bottom",
      end: "bottom top",
      once: true,
      toggleClass: {targets: el, className: "active"},
    });
  })


  const bottomfix = document.getElementById('bottomfix')
  ScrollTrigger.create({
    trigger: appContainer,
    //markers: true,
    start: "top center",
    end: "bottom top",
    toggleClass: {targets: bottomfix, className: "active"},
  });

  */

};